import React from 'react';
import PropTypes from 'prop-types';

const regionNames = {
  default: 'US',
  eu: 'Europe',
  au: 'Australia'
};

const TenantMenuItem = ({ name, region, selected, url }) => {
  const regionName = regionNames[region];

  return (
    <li className={`tenant-menu-item ${selected ? 'selected-tenant' : ''}`}>
      <a href={url} title={`${name} (${regionName})`}>
        <div className="tenant-name truncate">{name}</div>
        <span className="tenant-region">{regionName || region}</span>
      </a>
    </li>
  );
};

TenantMenuItem.propTypes = {
  name: PropTypes.string.isRequired,
  region: PropTypes.string.isRequired,
  selected: PropTypes.bool.isRequired,
  url: PropTypes.string.isRequired
};

export default TenantMenuItem;
